/**
 * ============================================================================
 * MOCK DATA BANNER — READ THIS BEFORE TRUSTING ANY NUMBER ON THIS DASHBOARD
 * ============================================================================
 *
 * Everything under `src/mock/` is SYNTHETIC PLACEHOLDER DATA generated in the
 * browser. It does not come from MetaTrader 5, from PostgreSQL, or from the Rust
 * daemon. No order was ever placed to produce it, and no broker deal exists
 * behind it.
 *
 * It exists for exactly one reason: the Rust API of §2/§12 has not been
 * implemented yet, so the seven pages of §3.2 need *some* correctly-shaped data
 * to render against while the contract in `src/api/types.ts` is being built.
 *
 * Rules this file obeys, so that nobody mistakes mock for live:
 *   - every payload is stamped `provenance: 'synthetic'`;
 *   - the ribbon, the KPI grid and the header all say MOCK DATA;
 *   - there is NO automatic fallback from live mode to mock mode. If live mode
 *     fails, the UI shows an error, never these fixtures;
 *   - nothing under `src/mock/` is imported by `src/api/client.ts`.
 *
 * Deleting `src/mock/` and building with `VITE_API_MODE=live` must leave a
 * compiling project that talks to the real daemon.
 */

/** Rendered by the sticky banner whenever synthetic data is on screen. */
export const MOCK_BANNER_TITLE = 'MOCK DATA — NOT CONNECTED TO MT5 OR THE RUST DAEMON';

export const MOCK_BANNER_BODY =
  'Every value on this dashboard is a synthetic placeholder generated in the browser so the UI can be built against the typed API contract. No MT5 demo account, no broker deals and no DeepSeek calls are behind any of it. Execution indicators are decorative: nothing in this build can place, modify or cancel an order.';

/** Provenance stamp attached to every mock payload. */
export const MOCK_PROVENANCE = 'synthetic' as const;

/** Standard warning line attached to every mock envelope. */
export const MOCK_WARNINGS = [
  'Synthetic dataset: values are generated locally and are not derived from MT5, PostgreSQL or the Rust daemon.',
  'Do not use any figure on this screen to make a trading decision.',
];
